import React, { Component } from 'react';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import {
  withStyles,
  Grid,
  Typography,
  Button,
  Menu,
  MenuItem,
  Badge,
  Avatar,
} from '@material-ui/core';

// import { Dashboard as DashboardLayout } from 'layouts';
import Projects from 'views/Projects';

import { FeaturedItem } from 'components';
import { getProject } from './_actions';
import { history } from 'utils/history';
import styles from './styles';
import { checkAccess } from 'services/accounts';
import { canAccess, getCurrentAccount, isAdminCurrent, toast } from 'utils/helpers';
import api from 'utils/api';

// Inject reducers
import { store } from 'utils/store';
import { projectsDashboard } from './_reducers';
import RecoveryPriceTable from 'components/RecoveryPriceTable';
import EstimateObjectList from '../EstimateObjectList/EstimateObjectList';
import ProjectRecordsList from '../ProjectRecordsList/ProjectRecordsList';
import RatesImportModal from '../EstimateObjectForm/RatesImportModal';
store.injectReducer('projectsDashboard', projectsDashboard);

let objectCount = {};


class ProjectsDashboard extends Component {

  state = {
    showRatesImportModal: false,
    openMenu: false,
    anchorEl: null,
    accessArchive: false,
    archivedCount: 0,
    isCompanyAdmin: false,
    isAdmin: false,
  }

  componentDidMount = async () => {
    const { match, dispatch } = this.props;
    if (match.path.includes('archive')) this.setState({ accessArchive: true });;

    if (match.params.id) {
      const currentAccount = getCurrentAccount();
      this.setState({
        isCompanyAdmin: _.get(currentAccount, 'company.owner') == currentAccount?._id,
        isAdmin: isAdminCurrent(),
      });

      dispatch(getProject(match.params.id));

      const { data } = await api.get(`/projects/${match.params.id}/count`);
      objectCount = data;

      const archivedCountRes = await api.get(`/projects/${match.params.id}/archived-count`);
      this.setState({ archivedCount: archivedCountRes.data.count });
    }
  }

  async checkDemoAccess(url) {
    try {
      await checkAccess();

      history.push(url);
    } catch (err) {
      window.alert(err.response.data.message);
    }
  }

  async handleProjectDelete() {
    const { project, t } = this.props;

    try {
      let countString = '';
      if (objectCount.objectCount) countString += `${objectCount.objectCount} ${t('sąmatų skaičiavimai')}`;
      if (objectCount.summaryCount) countString += `${countString.length ? ', ' : ''}${objectCount.summaryCount} ${t('suvestiniai skaičiavimai')}`;
      if (objectCount.recoveryPriceCount) countString += `${countString.length ? ', ' : ''}${objectCount.recoveryPriceCount} ${t('atkuriamosios vertės skaičiavimai')}`;

      if (!window.confirm(`${t('Ar tikrai norite pašalinti projektą')}? ${(countString.length ? `${t('Su projektu bus pašalinta')} ${countString}.` : '')}`)) return;

      await api.delete(`/projects/${project._id}/all`);
      toast(t('Projektas pašalintas'), 'success');
      history.push('/projects');
    } catch (err) {
      console.error(err);
      toast(t('Nepavyko pašalinti projekto'), 'error');
    }
  }

  async handleImportOpen(value) {
    this.setState({ showRatesImportModal: value });
  }

  handleClick(event) {
    this.setState({ openMenu: true });
    this.setState({ anchorEl: event.currentTarget })
  }

  renderServiceButtons() {
    const { classes, project, t } = this.props;

    if (!project) {
      return;
    }

    return (
      <Grid
        container
        spacing={4}
      >
        <Grid
          item
          lg={4}
          sm={6}
          xl={3}
          xs={12}
        >
          <FeaturedItem
            className={classes.item}
            subtitle={t('Paslauga')}
            title={t('Atkuriamoji vertė')}
            footerLink={`/projects/${project.id}/recovery-price/create`}
            footerClickHandler={() => this.checkDemoAccess(`/projects/${project.id}/recovery-price/create`)}
            footerText={t('Naujas skaičiavimas')}
          />
        </Grid>

        <Grid
          item
          lg={4}
          sm={6}
          xl={3}
          xs={12}
        >
          <FeaturedItem
            className={classes.item}
            subtitle={t('Paslauga')}
            title={t('Sąmatos')}
            footerLink={`/projects/${project.id}/objects/create${!canAccess('estimates.layout') ? '?trial=1' : ''}`}
            footerText={t('Naujas skaičiavimas')}
            footerClickHandler={() => this.checkDemoAccess(`/projects/${project.id}/objects/create${!canAccess('estimates.layout') ? '?trial=1' : ''}`)}
          />
        </Grid>

        <Grid
          item
          lg={4}
          sm={6}
          xl={3}
          xs={12}
        >
          <FeaturedItem
            className={classes.item}
            subtitle={t('Paslauga')}
            title={t('Suvestiniai skaičiavimai')}
            footerLink={`/projects/${project.id}/summaries/create${!canAccess('estimates.layout') ? '?trial=1' : ''}`}
            footerText={t('Naujas skaičiavimas')}
            footerClickHandler={() => this.checkDemoAccess(`/projects/${project.id}/summaries/create${!canAccess('estimates.layout') ? '?trial=1' : ''}`)}
          />
        </Grid>

        {/* <Grid
          item
          lg={3}
          sm={6}
          xl={3}
          xs={12}
        >
          <FeaturedItem
            className={classes.item}
            subtitle={t('Paslauga')}
            title={t('IFC peržiūra')}
            footerLink={`/projects/${project.id}/model-viewer${!canAccess('estimates.layout') ? '?trial=1' : ''}`}
            footerText={t('Atidaryti įrankį')}
            footerClickHandler={() => this.checkDemoAccess(`/projects/${project.id}/model-viewer${!canAccess('estimates.layout') ? '?trial=1' : ''}`)}
          />
        </Grid> */}
      </Grid>
    );
  }

  render() {
    const { classes, isLoading, project, t } = this.props;

    const title = (
      <span>
        Projektas
        {project ? (
          <React.Fragment>
            <Typography variant="h5">{`${project.title}${this.state.accessArchive ? ` (${t("Archyvas")})` : ''}`}</Typography>
          </React.Fragment>
        ) : null}
      </span>
    );

    return (
      <Projects
        title={title}
        // menu={menu}
        // menuTitle={menuTitle}
        isContentLoading={isLoading}
        breadcrumbs={[
          { title: t('Projektai'), to: '/projects' },
          { title: project ? project.title : '' },
          { title: t('Apžvalga') },
        ]}
        breadcrumbsObject={
          <div>
            <Badge
              color="error"
              variant="dot"
              overlap="rectangular"
              invisible={this.state.archivedCount == 0}
            >
              <Button
                style={{
                  marginLeft: 10,
                }}
                variant="contained"
                size="small"
                color="primary"
                onClick={(e) => this.handleClick(e)}
              >
                {t('Duomenų atstatymas')}
              </Button>
            </Badge>
            <Menu
              id="fade-menu"
              elevation={0}
              getContentAnchorEl={null}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
              transformOrigin={{ vertical: 'top', horizontal: 'center' }}
              anchorEl={this.state.anchorEl}
              keepMounted
              open={this.state.openMenu}
              onClose={() => this.setState({ openMenu: false })}
            >
              <MenuItem onClick={() => window.location.href = `/projects/${project._id}/dashboard/archive`}>
                <Typography>{t("Iš archyvo")}</Typography>
                {this.state.archivedCount > 0 &&
                  <Avatar
                    style={{
                      width: "16px",
                      height: "16px",
                      marginLeft: "3px",
                      fontSize: "12px",
                      backgroundColor: '#f44336',
                      color: '#fff',
                    }}
                  >
                    {this.state.archivedCount < 10 ? this.state.archivedCount : '9+'}
                  </Avatar>
                }
              </MenuItem>
              <MenuItem onClick={() => this.handleImportOpen(true)}>
                <Typography>{t("Iš laikmenų (Excel)")}</Typography>
              </MenuItem>
            </Menu>
            {!!this.state.accessArchive &&
              <Button
                style={{
                  marginLeft: 10,
                }}
                variant="contained"
                size="small"
                color="primary"
                onClick={() => window.location.href = `/projects/${project._id}/dashboard`}
              >
                {t('Grįžti')}
              </Button>
            }
            {project && (this.state.isAdmin || this.state.isCompanyAdmin) ? (
              <Button
                style={{
                  marginLeft: 10,
                  backgroundColor: '#dc004e',
                  color: '#ffffff'
                }}
                variant="contained"
                size="small"
                onClick={() => this.handleProjectDelete()}
              >
                {t('Pašalinti projektą')}
              </Button>
            ) : null}
          </div>
        }
      >

        {this.state.showRatesImportModal &&
          <RatesImportModal onClose={() => this.setState({ showRatesImportModal: false })} createEstimate={true} projectId={project._id} />
        }

        {project && !isLoading ? (
          <div className={classes.root}>
            {this.renderServiceButtons()}

            <div className={classes.verticalBlock}>
              <ProjectRecordsList projectId={project.id} accessArchive={this.state.accessArchive} />
              {/* <EstimateObjectList projectId={project.id} /> */}
            </div>

            {/* <div className={classes.verticalBlock}>
              <RecoveryPriceTable projectId={project.id} />
            </div> */}
          </div>
        ) : null}

      </Projects>
    );
  }
}

const mapStateToProps = ({ projectsDashboard, dispatch }) => {
  return {
    ...projectsDashboard,
    dispatch,
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
  withTranslation(),
)(ProjectsDashboard);
